// ChatGPT
import {
    chatgptMandatoryOptions,
    chatgptOptionalOptions,
    chatgptExcludedOptions,
} from "../../platforms/chatgpt/donationOptions";

// Gemini
import {
    geminiMandatoryOptions,
    geminiOptionalOptions,
    geminiExcludedOptions,
} from "../../platforms/gemini/donationOptions";

// Claude 
import {
    claudeMandatoryOptions,
    claudeOptionalOptions,
    claudeExcludedOptions,
} from "../../platforms/claude/donationOptions";

// DeepSeek 
import {
    deepseekMandatoryOptions,
    deepseekOptionalOptions,
    deepseekExcludedOptions,
} from "../../platforms/deepseek/donationOptions";

// Mistral 
import {
    mistralMandatoryOptions,
    mistralOptionalOptions,
    mistralExcludedOptions,
} from "../../platforms/mistral/donationOptions";

// Grok 
import {
    grokMandatoryOptions,
    grokOptionalOptions,
    grokExcludedOptions,
} from "../../platforms/grok/donationOptions";

// ---------- fomatting like public API ---------- 

// used in StepDonationOptions for the green card
export const donationOptionsMandatory = [
    ...chatgptMandatoryOptions,
    ...geminiMandatoryOptions,
    ...claudeMandatoryOptions,
    ...deepseekMandatoryOptions,
    ...mistralMandatoryOptions,
    ...grokMandatoryOptions,
]; 
// used in StepDonationOptions for the optional card
export const donationOptionsText = [
    ...chatgptOptionalOptions,
    ...geminiOptionalOptions,
    ...claudeOptionalOptions,
    ...deepseekOptionalOptions,
    ...mistralOptionalOptions,
    ...grokOptionalOptions,
];

// used in StepDonationOptions for the excluded list
export const excludedOptions = [
    ...chatgptExcludedOptions,
    ...geminiExcludedOptions,
    ...claudeExcludedOptions,
    ...deepseekExcludedOptions,
    ...mistralExcludedOptions,
    ...grokExcludedOptions,

];
